<template class="background-template">
  <div> <!-- Contenedor principal -->
      <div>
          <div class="login-keyboard">

            <div class="mesas-popup-custom" v-if="popupActivoModeMesero">
              <div class="popup-mesas-container">
                <!-- Encabezado con logo y botón de regreso -->
                <div class="popup-header">
                  <button class="back-button" @click="back_waiter()">
                    <i class="fas fa-long-arrow-alt-left"></i>
                  </button>
                  <div class="logo-container">
                    <img src="https://development.vinapp.co/logo2.jpg" alt="Logo" class="popup-logo">
                  </div>
                </div>
                
                <!-- Contenedor con scroll -->
                <div class="scroll-container">
                  <!-- Sección de Mis Mesas -->
                  <div class="mesas-section">
                    <h3 class="section-title">Mis Mesas</h3>
                    <div class="mesas-grid">
                      <div v-for="(table, index) in misMesasFiltradas" 
                            :key="'mis-mesas-'+index"
                            class="mesa-card">
                        <div class="mesa-content">
                          <div class="mesa-info" @click="select_table(table)">
                            <h4 v-if="show_table_name == 'true'">{{ table.name_table }}</h4>
                            <h4 v-else>Mesa #{{ table.id_table }}</h4>
                            <h5 v-if="table.name == null">Genérico</h5>
                            <h5 v-else>{{ table.name }}</h5>
                            <h5>${{ new Intl.NumberFormat("de-DE").format(table.total) }}</h5>
                            <span v-if="table.order_info && table.order_info.created_at" style="font-size:11px;color:#0B9BCF;font-weight:bold;">
                              🕒 {{ mesaTimers[table.id_table] || '00:00' }}
                            </span>
                          </div>
                          <div class="mesa-action" @click="select_table(table, true)">
                            <i class="fas fa-edit"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Divisor -->
                  <div class="section-divider"></div>
                  
                  <!-- Sección de Otras Mesas -->
                  <div class="mesas-section" v-if="otrasMesasFiltradas.length > 0">
                    <h3 class="section-title">Otras Mesas</h3>
                    <div class="mesas-grid">
                      <div v-for="(table, index) in otrasMesasFiltradas" 
                            :key="'otras-mesas-'+index"
                            class="mesa-card"
                            @click="select_table(table)">
                        <div class="mesa-content">
                          <h3 v-if="show_table_name == 'true'">{{ table.name_table }}</h3>
                          <h3 v-else>Mesa {{ table.number_table }}</h3>
                          <h5 v-if="table.nombre_mesero != null">{{ table.nombre_mesero }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
    import axios from '@/config/axios';
    
    export default {
        name: "TableWaiters",
        props: ["onFinish", "idCompany", "idPoint"],
        data() {
            return {
                popupActivoModeMesero: false,
                edit_other_table: localStorage.getItem('edit_other_table'),
                nombre_mesero: localStorage.getItem('nombre_mesero'),
                pinInput: '',
                id_company: localStorage.getItem('id_company'),
                errorLogin: null,
                active_login_with_code: localStorage.getItem('active_login_with_code'),
                select_waiters: localStorage.getItem('select_waiters'),
                show_table_name: localStorage.getItem('show_table_name'),
                table_list: {
                    mesas_ocupadas: [],
                    mesas: []
                },
                mesaTimers: {}, // <--- NUEVO: objeto para los contadores
                timerInterval: null // <--- NUEVO: referencia al setInterval
            }
        },
        computed: {
          misMesasFiltradas() {
            return this.table_list.mesas.filter(table => 
              table.nombre_mesero == this.nombre_mesero && table.id_order
            );
          },
          otrasMesasFiltradas() {
            if (this.edit_other_table == 'true') {
              return this.table_list.mesas.filter(table => 
                table.nombre_mesero != this.nombre_mesero && table.locator == false
              );
            } else {
              return this.table_list.mesas.filter(table => 
                table.nombre_mesero == null && table.locator == false && !table.id_order
              );
            }
          }
        },
        methods: {
            
            back_waiter(){
                localStorage.removeItem('nombre_mesero');
                localStorage.removeItem('id_user_mesero');
                localStorage.removeItem('punto');
                localStorage.removeItem('id_point_waiter');
                this.nombre_mesero = '';
                this.popupActivoModeMesero = false;
                this.onFinish(null)
            },
            select_table(table, edit_table = false){
              console.log('Mesa seleccionada:', table); 
                var form = {
                    nombre_mesero: localStorage.getItem('nombre_mesero'),
                    id_user_mesero: localStorage.getItem('id_user_mesero'),
                    punto: localStorage.getItem('punto'),
                    order_selected: table.order_info ? table.order_info : null,
                    edit_table: edit_table,
                    tableselected: table.number_table
                }
                this.onFinish(form);
            },
            getTableByPoint(){
                axios.get('/api/company/getusedtables/' + this.idCompany + '/' + this.idPoint)
                .then(res => {
                    this.table_list.mesas_ocupadas = res.data.info.mesas_ocupadas;
                    this.table_list.mesas = res.data.info.mesas;	// Todas las mesas de la licencia

                    if (this.show_table_name == 'true') {
                      this.table_list.mesas.forEach(m => {
                        m.name_table = m.name;
                      });
                    }
                    
                    this.table_list.mesas_ocupadas.forEach(m => {
                      if (m.nombre_mesero == null) {
                          m.nombre_mesero = 'Sin definir';
                      }
                    });

                    // Fusionar los atributos de mesas_ocupadas en mesas si coinciden en id_table/number_table
                    this.table_list.mesas.forEach(mesa => {
                        const mesaOcupada = this.table_list.mesas_ocupadas.find(m => m.id_table === mesa.number_table);
                        if (mesaOcupada) {
                            Object.assign(mesa, mesaOcupada);
                        }
                    });

                    this.popupActivoModeMesero = true;
                })
                .catch(err => {
                    console.error(err);
                });
            },
            updateMesaTimers() {
                // Recorre las mesas filtradas y actualiza el tiempo transcurrido
                this.misMesasFiltradas.forEach(table => {
                    if (table.order_info && table.order_info.created_at) {
                        const createdAt = new Date(table.order_info.created_at);
                        const now = new Date();
                        const diff = Math.floor((now - createdAt) / 1000); // segundos
                        this.$set(this.mesaTimers, table.id_table, this.formatTime(diff));
                    }
                });
            },
            formatTime(seconds) {
                const h = Math.floor(seconds / 3600);
                const m = Math.floor((seconds % 3600) / 60);
                const s = seconds % 60;
                return (
                  (h > 0 ? String(h).padStart(2, '0') + ':' : '') +
                  String(m).padStart(2, '0') + ':' +
                  String(s).padStart(2, '0')
                );
            },
            
        },
        mounted() {
          this.show_table_name = localStorage.getItem('show_table_name');
          this.edit_other_table = localStorage.getItem('edit_other_table');
          this.nombre_mesero = localStorage.getItem('nombre_mesero');
          this.getTableByPoint();
          // Iniciar el intervalo para actualizar los timers
          this.timerInterval = setInterval(() => {
            this.updateMesaTimers();
          }, 1000);
        },
        beforeDestroy() {
          if (this.timerInterval) {
            clearInterval(this.timerInterval);
          }
        },
    }
</script>

<style>
    .login-keyboard {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: rgba(255, 255, 255, 0.5);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .waiter-selector {
        width: 100%;
        max-width: 320px; /* Ancho máximo para mejor legibilidad */
        display: flex;
        justify-content: center;
    }

    .waiter-pin-section {
        border-radius: 20px;
        text-align: center;
        padding: 30px;
        background: white;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
        width: 100%;
    }

    .waiter-pin-input {
        width: 100%;
        max-width: 200px;
        padding: 12px;
        /*font-size: 24px;*/
        text-align: center;
        letter-spacing: 4px;
        border: 2px solid #ddd;
        border-radius: 8px;
        margin-bottom: 20px;
    }

    .pin-keypad {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        max-width: 300px;
        margin: 0 auto;
    }

    .pin-key {
        padding: 15px;
        font-size: 20px;
        border: none;
        border-radius: 8px;
        background: #f8f9fa;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .pin-key:hover {
        background: #e9ecef;
    }

    .pin-key.pin-clear {
        background: #dc3545;
        color: white;
    }

    .pin-key.pin-enter {
        background: #28a745;
        color: white;
    }

    .pin-key.pin-clear:hover {
        background: #c82333;
    }

    .pin-key.pin-enter:hover {
        background: #218838;
    }


    /*POPUP DE MESERO*/

    /* Contenedor principal */
.mesas-popup-custom {
  max-width: 800px;
  width: 90% !important;
  border-radius: 15px;
  overflow: hidden;
}

.popup-mesas-container {
  padding: 20px;
  font-family: 'Poppins', sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
}

/* Encabezado */
.popup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
}

.logo-container {
  width: 250px;
  height: 100px;
}

.popup-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.back-button {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: 2px solid #0B9BCF;
  color: #0B9BCF;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-button:hover {
  background: #0B9BCF;
  color: white;
}

/* Contenedor con scroll */
.scroll-container {
  overflow-y: auto;
  max-height: 60vh;
  padding-right: 10px;
  flex-grow: 1;
}

/* Personalización de la barra de scroll */
.scroll-container::-webkit-scrollbar {
  width: 8px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #0B9BCF;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #098fba;
}

/* Secciones */
.mesas-section {
  margin-bottom: 25px;
}

.section-title {
  text-align: left;
  padding-left: 15px;
  margin-bottom: 15px;
  color: #333;
  font-weight: 400;
}

.section-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 20px 0;
}

/* Grid de mesas */
.mesas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 15px;
}

/* Tarjetas de mesa */
.mesa-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.mesa-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.mesa-content {
  padding: 5px;
  position: relative;
}

.mesa-info {
  width: 75%;
}

.mesa-action {
  position: absolute;
  top: 0;
  right: 0;
  background: #0B9BCF;
  color: white;
  height: 100%;
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mesa-action:hover {
  background: #098fba;
}

.mesa-content h3 {
  font-size: 16px;
  margin-bottom: 5px;
  color: #333;
}

.mesa-content h4 {
  font-size: 14px;
  margin-bottom: 5px;
  color: #444;
}

.mesa-content h5 {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

/* Responsive */
@media (max-width: 768px) {
  .mesas-grid {
    grid-template-columns: 1fr;
  }
  
  .mesa-card {
    max-width: 100%;
  }
  
  .scroll-container {
    max-height: 50vh;
  }
}
</style>
